import { Node } from "models/system";

const initialState: Array<Node> = [];

export default initialState;
